import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import {ScaleLoader} from "react-spinners";

const VenuesList = ({loadMore, hasMore, venues}) =>
        (
            <React.Fragment>
                { venues.length === 0 ?
                    <div className="text-secondary pt-5">Er werden geen zalen gevonden.</div>
                    :
                <InfiniteScroll
                    pageStart={0}
                    loadMore={loadMore}
                    hasMore={hasMore}
                    loader={<div className="loader text-primary font-size-lg text-center p-3" key={0}><ScaleLoader/></div>}
                >
                    <div className="row">
                        { venues.map(venue =>
                            <div className="col-md-6" dangerouslySetInnerHTML={{__html: venue.render}}/>
                        )}
                    </div>
                </InfiniteScroll>
                }
            </React.Fragment>
        )
;

export default VenuesList;